import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import ReportPortfolioAtRiskByAging from "../reports/ReportPortfolioAtRiskByAging";


function PortfolioAtRiskByAging() {
    return (
        <>
            <NavMain slug="portfolio-at-risk-by-aging" parent="4" />
            <HeaderMain slug="portfolio-at-risk-by-aging" />
            <div className="main-content">
                <ReportPortfolioAtRiskByAging />
            </div>
        </>
    );
}

export default PortfolioAtRiskByAging;